import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { ArrowRight, Phone, MessageSquare, ClipboardList, Truck, Heart, Star } from 'lucide-react';

const STEPS = [
  { icon: Phone, step: "01", title: "Prise de contact", desc: "Remplissez notre formulaire en ligne ou appelez-nous. Un conseiller dédié prend en charge votre demande sous 48 heures ouvrées." },
  { icon: MessageSquare, step: "02", title: "Qualification du besoin", desc: "Nous analysons en détail votre situation : besoins de mobilité, niveau d'assistance, préférences de destination, période, budget. Chaque dossier est unique." },
  { icon: ClipboardList, step: "03", title: "Proposition personnalisée", desc: "Sur la base de votre profil, nous sélectionnons les partenaires les plus adaptés et élaborons une proposition de séjour sur mesure, détaillée et transparente." },
  { icon: Truck, step: "04", title: "Coordination logistique", desc: "Transport adapté, matériel de mobilité, intervenants sur place : nous coordonnons l'ensemble des prestations et nous assurons que tout est en place pour votre départ." },
  { icon: Heart, step: "05", title: "Préparation du départ", desc: "Nous préparons la continuité d'accompagnement avec vos professionnels habituels. Un dossier complet est transmis aux intervenants sur le lieu de séjour." },
  { icon: Star, step: "06", title: "Suivi et satisfaction", desc: "Pendant le séjour, nous restons joignables. Après le retour, nous réalisons un bilan de satisfaction pour améliorer continuellement notre service." }
];

export default function HowItWorksPage() {
  return (
    <div className="min-h-screen py-24 md:py-32 bg-background" data-testid="how-it-works-page">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <span className="text-sm font-medium tracking-wider uppercase text-primary mb-3 block">Parcours</span>
          <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground mb-4">Comment ça marche ?</h1>
          <p className="text-base md:text-lg text-muted-foreground max-w-2xl mx-auto">
            Un parcours simple et structuré en 6 étapes pour des vacances sans stress ni improvisation.
          </p>
        </div>

        <div className="space-y-6">
          {STEPS.map(({ icon: Icon, step, title, desc }, i) => (
            <div key={step} className="flex gap-6 items-start">
              <div className="flex flex-col items-center">
                <div className="w-14 h-14 rounded-2xl bg-primary text-primary-foreground flex items-center justify-center font-heading text-lg font-bold">
                  {step}
                </div>
                {i < STEPS.length - 1 && <div className="w-px h-full min-h-[40px] bg-border mt-2" />}
              </div>
              <div className="bg-white rounded-2xl p-6 md:p-8 border border-border/30 shadow-sm flex-1 hover:shadow-md transition-all">
                <div className="flex items-center gap-3 mb-3">
                  <Icon className="w-5 h-5 text-primary" />
                  <h3 className="font-heading text-lg font-semibold text-foreground">{title}</h3>
                </div>
                <p className="text-muted-foreground leading-relaxed">{desc}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <Link to="/demander-un-sejour">
            <Button className="rounded-full bg-accent text-accent-foreground px-8 py-6 text-lg font-semibold hover:bg-accent/90 hover:scale-105 transition-all shadow-lg" data-testid="how-cta">
              Commencer maintenant <ArrowRight className="ml-2 w-5 h-5" />
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
}
